import { getShopifyData } from "./config";

export const RemoveFromCart = async (cartId, lineId) => {
  const query = `mutation removeFromCart($cartId: ID!, $lineIds: [ID!]!) {
  cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
    userErrors {
      code
      field
      message
    }
    cart {
      id
      totalQuantity
      checkoutUrl
      cost {
        totalAmount {
          amount
          currencyCode
        }
        subtotalAmount {
          amount
          currencyCode
        }
        totalTaxAmount {
          amount
          currencyCode
        }
        totalDutyAmount {
          amount
          currencyCode
        }
      }
      lines(first: 20) {
        nodes {
          id
          quantity
          merchandise {
            ... on ProductVariant {
              id
              title
              quantityAvailable
              product {
              title
              options {
                name
                optionValues {
                  name
                }
              }
              variants(first: 100) {
                nodes {
                  id
                  sku
                  title
                  availableForSale
                  quantityAvailable
                  price {
                    amount
                  }
                  compareAtPrice {
                    amount
                  }
                  selectedOptions {
                    name
                    value
                  }
                  currentlyNotInStock
                }
              }
            }
              price {
                amount
              }
              image {
                altText
                url(transform: {preferredContentType: WEBP})
              }
              sku
              selectedOptions {
                name
                value
              }
            }
          }
        }
      }
    }
  }
}`;

  const response = await getShopifyData(query, {
    cartId: cartId,
    lineIds: [lineId],
  });

  return response.data?.cartLinesRemove;
};
